import React from "react";
import CustomLayout from "../Layout/CustomLayout";
import { Result, Typography } from "antd";
import typoStyles from "../../styles/Custom/Typography.module.css";
import { SmileOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import Facilities from "./Facilities/Facilities";
import { capitalizeFirstLetter } from "../../helpers/utility";
import DietMenu from "./DietMenu/DietMenu";
import AccountDetails from "../Account/Details";
import SideMenu from "../Layout/CustomLayout/SideMenu";
import Medication from "./Medication/Medication";
import Users from "./Users/Users";
import Investigations from "./Investigations/Investigations";
import Services from "./Services/Services";
import PatientsTable from "./Patients/PatientsTable";
import PartnerOnboarding from "../Receptionist/PartnerOnboarding/PartnerOnboarding";
import OrgDashboard from "./OrgDashboard/OrgDashboard";
import IPDashboard from "./IPDashboard/IPDashboard";
import OPDashboard from "./OPDashboard/OPDashboard";
import Operations from "./Operations/Operations";
import Therapies from "../Receptionist/Therapies/Therapies";
import ServiceRequestsMenu from "./ServiceRequests/ServiceRequestsMenu";
import UsageOverview from "./UsageOverview/UsageOverview";
import FacilityIpWhitelisting from "./Settings/IpWhitelisting/FacilityIpWhitelisting";

const Dashboard = () => {
  const query = useParams();
  // console.log(query["*"]);

  const renderContent = () => {
    switch (query["*"]) {
      case "home/overview":
        return <OrgDashboard />;
      case "home/ip-dashboard":
        return <IPDashboard />;
      case "home/op-dashboard":
        return <OPDashboard />;
      case "home/operations":
        return <Operations />;
      case "home/final-discharge-dashboard":
        return <IPDashboard />;
      case "facilities":
        return <Facilities />;
      case "diet-menu":
        return <DietMenu />;
      case "service-requests":
        return <ServiceRequestsMenu />;
      case "details":
        return <AccountDetails />;
      case "users":
        return <Users />;
      case "investigation":
        return <Investigations />;
      case "medication":
        return <Medication />;
      case "services":
        return <Services />;
      case "usage-overview":
        return (
          <CustomLayout
            header={
              <Typography className={typoStyles.h6}>Usage Overview</Typography>
            }
            sideContent={<SideMenu />}
          >
            <UsageOverview />
          </CustomLayout>
        );
      case "partner_onboarding":
        return (
          <CustomLayout
            header={
              <Typography className={typoStyles.h6}>
                Partner Onboarding
              </Typography>
            }
            sideContent={<SideMenu />}
          >
            <PartnerOnboarding />
          </CustomLayout>
        );
      case "therapies":
        return (
          <CustomLayout
            header={
              <Typography className={typoStyles.h6}>Therapies</Typography>
            }
            sideContent={<SideMenu />}
          >
            <Therapies />
          </CustomLayout>
        );

      case "patients":
        return (
          <CustomLayout
            header={
              <Typography className={typoStyles.h6}>
                {capitalizeFirstLetter(query["*"])}
              </Typography>
            }
            sideContent={<SideMenu />}
          >
            <PatientsTable />
          </CustomLayout>
        );
        case "settings/ip-whitelisting":
        return <FacilityIpWhitelisting />;
      default:
        return (
          <CustomLayout
            header={
              <Typography className={typoStyles.h6}>
                {capitalizeFirstLetter(query["*"])}
              </Typography>
            }
            sideContent={<SideMenu />}
          >
            <Result
              icon={<SmileOutlined style={{ color: "#101828" }} />}
              title="Coming soon!!"
            />
          </CustomLayout>
        );
    }
  };

  return <>{renderContent()}</>;
};

export default Dashboard;
